<template>
  <v-layout
      row
      align-center
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <v-card
          class="pa-2 mx-auto col-sm-3"
          outlined
      >
        <v-container fluid>
          <v-snackbar
              v-model="error"
              color="error"
              :timeout="5000"
              top
          >
            {{ msg }}
          </v-snackbar>
          <v-row dense>
            <v-col>
              <v-row align="center" justify="center">
                <v-img
                    v-if="logo"
                    class="justify-center"
                    :src="myLogo"
                    height="100"
                    width="100"
                    alt="logo"
                    contain
                />
              </v-row>
              <v-card-title class="justify-center" style="font-size: large;">{{ title }}</v-card-title>
              <div>
                <div class="col">
                  <v-form
                      method="post"
                      action="https://www.getform.org/f/[YOUR-FORM-ID]"
                      id="loginForm"
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      @submit.prevent="submit"
                  >
                    <v-text-field
                        color="indigo"
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        outlined
                        autocomplete="off"
                    ></v-text-field>

                    <v-text-field
                        color="indigo"
                        v-model="password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required]"
                        :type="showPassword ? 'text' : 'password'"
                        label="Password"
                        outlined
                        @click:append="showPassword = !showPassword"
                        autocomplete="off"
                    ></v-text-field>

                    <v-btn
                        color="indigo"
                        class="mt-8 mb-2 col text-white font-weight-bold"
                        type="submit"
                    >
                      Login
                    </v-btn>
                  </v-form>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    rules: {
      required: value => !!value || 'Required.',
    },
    showPassword: false,
    outlet: null,
    title: '',
    logo: '',
    error: false,
    msg: '',
  }),
  props: ['outlet_id'],
  computed: {
    myLogo() {
      return '/storage' + this.logo;
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        axios.post('/login', {
          email: this.email,
          password: this.password
        }).then(response => {
          window.location.href = '/'
        }).catch(e => {
          this.error = true;
          this.msg = 'Please check your login credentials.'
        })
      } else {
        this.error = true;
        this.msg = 'Please check your login credentials.'
      }
    },
    register() {
      window.location.href = '/register'
    }
  },
  beforeMount() {
    axios.get('/api/getOutletForLogin/?oid=' + this.outlet_id).then(response => {
      this.title = response.data ? response.data.name : 'Queue Management System';
      this.logo = response.data ? response.data.logo : '';
    });
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Login.vue